import Footer from "./components/footer/footer";
import MainContent from "./components/MainContent";
import Navbar from "./components/navigation/Navbar";
// Vercel Analytics temporarily disabled due to react-scripts 4.0.3 compatibility issues
// To enable: upgrade react-scripts to 5.x or use CRACO to configure webpack
// import { Analytics } from "@vercel/analytics/react";
 
function App() {
  return (
    <>
      <Navbar />
      <MainContent />
      <Footer />
      {/* <Analytics /> */}
    </>
  );
}

export default App;
